import Vue from "vue";
import Str from "@/helper/Str";

Vue.filter("capitalize", function (value: string): string {
  //if (!value) return "";
  //return value.charAt(0).toUpperCase() + value.slice(1);
  return Str.capitalize(value);
});
